import React from 'react';

import SvgIcon, { SvgIconProps } from './SvgIcon';

const MinusIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox={[448, 512]}
    d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
  />
);

export default MinusIcon;
